<section class="h-100">
  <div class="create-password d-flex justify-content-around align-items-start">
    <div class="w-60 create-password__divider">
      <app-create-password-form></app-create-password-form>
    </div>
    <div class="w-40 create-password__divider">
      <div
        class="create-password__cover d-flex align-items-center justify-content-center p-5 p-md-3">
        <img
          src="assets/images/logo-cognito.svg"
          alt="Legatus Growth Partner"
          title="Legatus Growth Partner"
          class="create-password__cover__logo img-fluid" />
      </div>
    </div>
  </div>
</section>
